import React from "react";
import { useIntl } from "react-intl";

import { Tupel } from "components";

interface IZusatzleistungen {
  financeRate: {
    wearIncluded?: boolean;
    maintenanceIncluded?: boolean;
  };
}
const Zusatzleistungen: React.FC<IZusatzleistungen> = ({
  financeRate: { wearIncluded = false, maintenanceIncluded = false },
}): JSX.Element | null => {
  const { formatMessage: t } = useIntl();
  if (!(wearIncluded || maintenanceIncluded)) return null;

  const label = t(
    {
      id: "page.detail.finance.zusatzleistungen.label",
      defaultMessage:
        "{count, plural, one {Zusatzleistung} other {Zusatzleistungen}}",
    },
    { count: wearIncluded && maintenanceIncluded ? 2 : 1 },
  );

  const title = t(
    {
      id: "page.detail.finance.zusatzleistungen.title",
      defaultMessage:
        "{variant, plural, =0 {Verschleiß} =1 {Wartung} other {Verschleiß und Wartung}} in Rate enthalten.",
    },
    {
      variant:
        wearIncluded && maintenanceIncluded ? 0 : maintenanceIncluded ? 1 : 0,
    },
  );
  const title2 =
    (wearIncluded &&
      maintenanceIncluded &&
      t(
        {
          id: "page.detail.finance.zusatzleistungen.title",
          defaultMessage:
            "{variant, plural, =0 {Verschleiß} =1 {Wartung} other {Verschleiß und Wartung}} in Rate enthalten.",
        },
        {
          variant: 1,
        },
      )) ||
    null;
  return (
    <>
      <Tupel
        label={label}
        text={title}
        boxProps={{ fontWeight: "bold" }}
        divider={!(wearIncluded && maintenanceIncluded)}
      />
      {title2 && <Tupel text={title2} boxProps={{ fontWeight: "bold" }} />}
    </>
  );
};
export default Zusatzleistungen;
